export enum smsAutoReplySettingsEnum {
  RPM = 'RPM',
  SETUP = 'SETUP',
  STRIPS = 'STRIPS',
  BATTERIES = 'BATTERIES',
  CONSUMABLES = 'CONSUMABLES',
  CONSUMABLES_ES = 'CONSUMABLES_ES',
  NUMBER_80 = 'NUMBER_80',
  NUMBER_81 = 'NUMBER_81',
  NUMBER_82 = 'NUMBER_82',
  NUMBER_83 = 'NUMBER_83',
  NUMBER_90 = 'NUMBER_90',
  NUMBER_91 = 'NUMBER_91',
  NUMBER_92 = 'NUMBER_92',
  NUMBER_93 = 'NUMBER_93',
  BINGO = 'BINGO',
  BINGO_NUMBER = 'BINGO_NUMBER',
  CALL_ME = 'CALL_ME',
  CALL_ME_ES = 'CALL_ME_ES',
}
